<div class="login-container">
    <div class="logo-section">
        <div class="logo-text">
            <div class="logo-image-wrapper">
                <img src="assets/images/logo.png" alt="Resulth Car Logo" class="logo-image">
            </div>
        </div>
    </div>

    <div class="login-card">
        <div class="header">
            <h1>Login</h1>
            <p>Acesso ao sistema de abertura de OS do ResulthCar</p>
        </div>

        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
            <div class="form-group">
                <label for="identifier">Usuário</label>
                <div class="input-wrapper">
                    <input type="text" id="identifier" formControlName="identifier" placeholder="E-mail ou CPF" autocomplete="username">
                </div>
            </div>

            <div class="form-group">
                <label for="password">Senha</label>
                <div class="input-wrapper">
                    <input [type]="showPassword ? 'text' : 'password'" id="password" formControlName="password" placeholder="..............." autocomplete="current-password">
                    <button type="button" class="eye-toggle" (click)="showPassword = !showPassword" [attr.aria-label]="showPassword ? 'Ocultar senha' : 'Mostrar senha'">
                        <svg *ngIf="!showPassword" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                            <circle cx="12" cy="12" r="3"/>
                        </svg>
                        <svg *ngIf="showPassword" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                            <line x1="1" y1="1" x2="23" y2="23"/>
                        </svg>
                    </button>
                </div>
            </div>

            <div class="form-group" *ngIf="requiresBaseSelection">
                <label for="baseAcessoId">Base de acesso</label>
                <div class="input-wrapper select-wrapper">
                    <select id="baseAcessoId" formControlName="baseAcessoId">
                        <option value="" disabled selected>Selecione uma base</option>
                        <option *ngFor="let base of availableBases" [value]="base.id">{{ base.descricao }}</option>
                    </select>
                    <svg class="select-chevron" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="6 9 12 15 18 9"/>
                    </svg>
                </div>
            </div>

            <p class="error-message" *ngIf="errorMessage">{{ errorMessage }}</p>

            <button type="submit" class="btn-login"
                [disabled]="loginForm.invalid || isLoading || (requiresBaseSelection && !loginForm.value.baseAcessoId)">
                <span>{{ submitLabel }}</span>
                <span class="arrow" *ngIf="!isLoading">→</span>
            </button>
        </form>
    </div>
</div>
